import React from 'react'
import Button from '@mui/material/Button'
import { Dialog } from '@mui/material'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'

import './IARDialog.scss'
import PropTypes from 'prop-types'
import { FaBars } from 'react-icons/fa'

function IARDialog(props) {
  const { onOk, onCancel, title, content, open, previewNotSaved = false  } = props
  const handleCancel = () => {
    onCancel()
  }

  const handleOk = () => {
    onOk()
  }

  return (
    <Dialog className="custom-dialog"
      disableEscapeKeyDown
      onClose={(_, reason) => { if (reason !== 'backdropClick') handleCancel() }}
      open={open}
    >
      <FaBars className="bars"/>
      <DialogTitle className="custom-dialog-title">
        <span>{title}</span>
      </DialogTitle>
      <DialogContent className="custom-dialog-content">
        { content }
      </DialogContent>
      <DialogActions className="custom-dialog-actions">
        {!previewNotSaved &&
        <Button
          autoFocus
          onClick={handleCancel}
          color="primary"
          variant="outlined">
          Cancel
        </Button>}
        <Button
          onClick={handleOk}
          color="primary"
          variant="contained">
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  )
}

IARDialog.propTypes = {
  title: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  open: PropTypes.bool,
  onOk: PropTypes.func,
  onCancel: PropTypes.func
}

export { IARDialog }
